// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iHb5SLtlk97o_5_GH_QZ {
  height: 60px !important;
}
.iHb5SLtlk97o_5_GH_QZ[data-is-current-player='true'] {
  position: relative;
  border-radius: 5px;
  z-index: 0;
}
.iHb5SLtlk97o_5_GH_QZ[data-is-current-player='true']::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 5px;
  padding: 2px;
  background: linear-gradient(90deg, #dc9300, #fece02, #fffa2f, #fff933, #f9c419, #c59029, #b16c04, #b16c04, #fbce35);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: -1;
}
.Jr1YT1fdHnVENv4Nf1_L {
  flex-direction: column;
  line-height: normal;
}
.PSVE4jmUehYy05xnBvU1 {
  color: white;
  font-size: 21px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: 0.17px;
  font-family: var(--font-family-primary, inherit);
}
.srVDxNWNq1FjALYFBU3I {
  color: #B5B5B5;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: 0.17px;
  white-space: nowrap;
  font-family: var(--font-family-primary, inherit);
}
.ZvdFqJnLv1NcirUziRzw {
  white-space: nowrap;
}
.a9SfZJx1hmtLtGD8brDA {
  color: #FFDF1A;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.17px;
}
.LrRwpGbdcZzzVD4vgtxa {
  font-size: 13px;
  align-self: end;
}
.Iw3bEUxlNOufphN84HEA {
  text-align: center;
}
.bVPDhVikn3W8OeSMEDQl {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  cursor: pointer;
}
.XHtWKRMCQfbY4SDfh2Oe {
  border-radius: 8%;
  height: 48px;
  width: 48px;
}
.XHtWKRMCQfbY4SDfh2Oe img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.amQkyWwrcN8xHIbnYDOE {
  height: 100%;
  width: 100%;
  position: relative;
  display: block;
}
.dwAQjCf58Vl4DUght8s8 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 8px auto;
  height: 41dvh;
  background-color: #1c1c1e;
  border-radius: 8px;
  padding: 1rem;
  max-width: 60%;
}
.YZlW1SuBBOqFME4gmoc2 {
  color: var(--campaign-color-text-grey);
  font-size: 1.125rem;
  font-weight: 500;
  text-align: center;
}
.u8bI1KoMydfBQs_UMnvp {
  height: 225px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: var(--campaign-color-text-grey);
  font-size: 1.125rem;
  font-weight: 500;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .iHb5SLtlk97o_5_GH_QZ {
    height: 40px !important;
  }
  .PSVE4jmUehYy05xnBvU1 {
    font-size: 14px;
  }
  .srVDxNWNq1FjALYFBU3I {
    font-size: 12px;
  }
  .a9SfZJx1hmtLtGD8brDA {
    font-size: 15px;
  }
  .LrRwpGbdcZzzVD4vgtxa {
    font-size: 9px;
  }
  .XHtWKRMCQfbY4SDfh2Oe {
    height: 32px;
    width: 32px;
  }
  .u8bI1KoMydfBQs_UMnvp {
    font-size: 16px;
  }
  .dwAQjCf58Vl4DUght8s8 {
    max-width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/prizePop/tabs/WinnersTab/WinnersTab.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mHAAmH;EACnH,8EAA8E;EAC9E,sEAAsE;EACtE,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".winnersTableRow {\n  height: 60px !important;\n}\n.winnersTableRow[data-is-current-player='true'] {\n  position: relative;\n  border-radius: 5px;\n  z-index: 0;\n}\n.winnersTableRow[data-is-current-player='true']::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 5px;\n  padding: 2px;\n  background: linear-gradient(90deg, #dc9300, #fece02, #fffa2f, #fff933, #f9c419, #c59029, #b16c04, #b16c04, #fbce35);\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  z-index: -1;\n}\n.playerCell {\n  flex-direction: column;\n  line-height: normal;\n}\n.playerCellId {\n  color: white;\n  font-size: 21px;\n  font-weight: 400;\n  line-height: 1.1;\n  letter-spacing: 0.17px;\n  font-family: var(--font-family-primary, inherit);\n}\n.date {\n  color: #B5B5B5;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.1;\n  letter-spacing: 0.17px;\n  white-space: nowrap;\n  font-family: var(--font-family-primary, inherit);\n}\n.prizeCell {\n  white-space: nowrap;\n}\n.prizeAmount {\n  color: #FFDF1A;\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: 0.17px;\n}\n.currencyCode {\n  font-size: 13px;\n  align-self: end;\n}\n.gameCell {\n  text-align: center;\n}\n.gameInfo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: center;\n  cursor: pointer;\n}\n.gameThumbnail {\n  border-radius: 8%;\n  height: 48px;\n  width: 48px;\n}\n.gameThumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.loaderContainer {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: block;\n}\n.noDataWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 8px auto;\n  height: 41dvh;\n  background-color: #1c1c1e;\n  border-radius: 8px;\n  padding: 1rem;\n  max-width: 60%;\n}\n.noDataText {\n  color: var(--campaign-color-text-grey);\n  font-size: 1.125rem;\n  font-weight: 500;\n  text-align: center;\n}\n.campaignNotActive {\n  height: 225px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: var(--campaign-color-text-grey);\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n@media (--campaign-mobile) {\n  .winnersTableRow {\n    height: 40px !important;\n  }\n  .playerCellId {\n    font-size: 14px;\n  }\n  .date {\n    font-size: 12px;\n  }\n  .prizeAmount {\n    font-size: 15px;\n  }\n  .currencyCode {\n    font-size: 9px;\n  }\n  .gameThumbnail {\n    height: 32px;\n    width: 32px;\n  }\n  .campaignNotActive {\n    font-size: 16px;\n  }\n  .noDataWrapper {\n    max-width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"winnersTableRow": `iHb5SLtlk97o_5_GH_QZ`,
	"playerCell": `Jr1YT1fdHnVENv4Nf1_L`,
	"playerCellId": `PSVE4jmUehYy05xnBvU1`,
	"date": `srVDxNWNq1FjALYFBU3I`,
	"prizeCell": `ZvdFqJnLv1NcirUziRzw`,
	"prizeAmount": `a9SfZJx1hmtLtGD8brDA`,
	"currencyCode": `LrRwpGbdcZzzVD4vgtxa`,
	"gameCell": `Iw3bEUxlNOufphN84HEA`,
	"gameInfo": `bVPDhVikn3W8OeSMEDQl`,
	"gameThumbnail": `XHtWKRMCQfbY4SDfh2Oe`,
	"loaderContainer": `amQkyWwrcN8xHIbnYDOE`,
	"noDataWrapper": `dwAQjCf58Vl4DUght8s8`,
	"noDataText": `YZlW1SuBBOqFME4gmoc2`,
	"campaignNotActive": `u8bI1KoMydfBQs_UMnvp`
};
export default ___CSS_LOADER_EXPORT___;
